import React from 'react';
import { RIP_LIST } from '../../utilities/constants/Constants';
import './TileView.scss';

// If i declare this class as functional compoenent it doesnt render the children (ie. RIPLIST)
class TileView extends React.PureComponent {
  state = {};

  render() {
    const { click, styles, ripsTileView, isRipSelected } = this.props;

    return (
      <div className='ripsBlock' style={styles}>
        {RIP_LIST.map((list, index) =>
          index > 1 ? (
            <div
              role='button'
              tabIndex='0'
              style={ripsTileView}
              className={
                isRipSelected == index ? 'tileBlockSelected ' : 'tileBlock'
              }
              onClick={() => click(index)}
              onKeyPress={() => {}}
            >
              <img src={list.img} alt='rip' />
              <p
                className={
                  isRipSelected == index
                    ? 'ripsBlockTextSelected '
                    : 'ripsBlockText'
                }
              >
                {list.message}
              </p>
            </div>
          ) : null
        )}
      </div>
    );
  }
}

export default TileView;
